import { useParams } from 'react-router-dom';
import './Order.css';
import { LogoIcon } from '../../assets/icons/icons';
import { IMG_PLACEHOLDER_PRODUCT } from '../../assets/utils/constants';
import { getCorrectWordForm, parsePrice, parseTitleForParts } from '../../assets/utils/utils';
import { useEffect, useState } from 'react';
import mainApi from '../../assets/api/MainApi';
import MiniPreloader from '../MiniPreloader/MiniPreloader';
const item = {
    name: 'ROLEX || OYSTER'
}
function Order() {
    const { id } = useParams()

    const [preloader, setPreloader] = useState({
        getOrder: true,
    })
    const [order, setOrder] = useState(null)

    useEffect(() => {
        setPreloader(prevValue => ({
            ...prevValue,
            getOrder: true,
        }))
        mainApi.getOrderById({ _id: id })
            .then((res) => {
                console.log(res)
                setOrder(res)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setPreloader(prevValue => ({
                    ...prevValue,
                    getOrder: false,
                }))
            })
    }, [id])
    return (
        <div className='order'>
            {preloader.getOrder ?
                <div className='order__preloader'>
                    <MiniPreloader />
                </div>

                :
                order ?
                    <>
                        <div className='order__info'>
                            <div className='order__header'>
                                <LogoIcon mainClassName={'order__header-logo'} fillClassName={'order__header-logo-fill'} />
                            </div>
                            <div className='order__number'>
                                <div className='order__number-box'>
                                    <p className='order__number-title'>Order Number:</p>
                                    <p className='order__number-value'>{`№${("00000000" + order.ai_id).slice(-8)}`}</p>
                                </div>
                            </div>
                            {order.order_items && order.order_items.length > 0 ?
                                <div className='order__items'>
                                    {order.order_items.map((order_item, i) => {
                                        const item = order_item.item ? order_item.item : order_item
                                        return (
                                            <div className='order__item' key={`order__item${i}`}>
                                                <img
                                                    // src={IMG_PLACEHOLDER_PRODUCT}
                                                    src={item.files && item.files.length > 0 ? item.files[0].urls.orig : IMG_PLACEHOLDER_PRODUCT}
                                                    className='order__item-img'
                                                    alt=''
                                                />
                                                <div className='order__item-info'>
                                                    <h3 className={`order__item-info-title`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).title : ` `}</h3>
                                                    <p className={`order__item-info-subtitle`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).subtitle : ` `}</p>
                                                    <div className='order__item-info-separator'></div>
                                                    <div className='order__item-info-price-and-count'>
                                                        <p className='order__item-info-price'>{parsePrice(order_item.price, 'USD')}</p>
                                                        <div className='order__item-info-price-and-count-separator' />
                                                        <p className='order__item-info-count'>{order_item.amount} {getCorrectWordForm('pc.')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                : null}

                            <div className='order__total'>
                                <p className='order__total-title'>Total:</p>
                                <p className='order__total-value'>{parsePrice(order.total_price, 'USD')}</p>
                            </div>
                        </div>
                        {order.url ?
                            <button className='order__btn' type='button' onClick={() => {
                                window.location.href = order.url
                                return
                            }}>
                                Pay {parsePrice(order.total_price, order.payment_type === "cryptocloud" ? 'USDT' : 'USD')}
                            </button>
                            : null}

                    </>
                    :
                    <p>404</p>
            }

        </div>
    );
}

export default Order